import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { useSiteContent } from "@/context/SiteContentContext";
import { buildWhatsAppLink } from "@/lib/cms";

export default function SocialLinks() {
  const { socialLinks, settings } = useSiteContent();

  const whatsappNumber = String(settings.whatsapp_number || "");
  const whatsappMessage = String(settings.whatsapp_message || "");

  return (
    <section id="redes" className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Redes sociales"
          title={`Conecta con ${String(settings.brand || "MARK DIRECT COMPANY")}`}
        />

        <div className="mt-12 flex flex-wrap justify-center gap-4">
          {socialLinks.map((social, i) => {
            const isWhatsApp = social.nombre.toLowerCase() === "whatsapp";
            const url = isWhatsApp
              ? buildWhatsAppLink(whatsappNumber, whatsappMessage)
              : social.url || "";
            const hasUrl = Boolean(url);
            const inner = (
              <span
                className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl border transition-all duration-300 ${
                  hasUrl
                    ? "border-background-200 bg-background-50 text-foreground-700 hover:-translate-y-1.5 hover:border-primary-300 hover:text-primary-600 hover:shadow-[0_12px_28px_oklch(var(--primary-500)/0.2)] cursor-pointer"
                    : "border-background-200 bg-background-50 text-foreground-300 cursor-not-allowed"
                }`}
              >
                <i className={`${social.icono || "ri-link"} text-2xl`} />
              </span>
            );

            return (
              <Reveal key={social.id} delay={i * 60}>
                <div className="flex flex-col items-center gap-2">
                  {hasUrl ? (
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.nombre}
                      title={social.nombre}
                    >
                      {inner}
                    </a>
                  ) : (
                    <span title={`${social.nombre} — configurar enlace`}>{inner}</span>
                  )}
                  <span className="text-[11px] font-medium text-foreground-400">
                    {social.nombre}
                  </span>
                </div>
              </Reveal>
            );
          })}
        </div>

        {socialLinks.length === 0 && (
          <p className="mt-12 text-center text-foreground-500">
            Pronto conectaremos nuestras redes sociales.
          </p>
        )}
      </div>
    </section>
  );
}